"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'workEfficiency',
      searchQuery: {
        type: '1',
        value: curDateTree.month,
        srEmpNo: '',
        srEmpName: ''
      },
      apiModule: 'kpiSet',
      urlModule: 'REPORT'
    };
  },
  computed: {
    domData: function domData() {
      return {
        // srEmpNo: {
        //   label: this.$t("sfe.workEfficiency.srEmpNo"),
        //   valueKey: "srEmpNo"
        // },
        srEmpName: {
          label: this.$t('sfe.workEfficiency.srEmpName'),
          valueKey: 'srEmpName'
        },
        value: {
          label: this.$t('common.month'),
          valueKey: 'value',
          inputType: 'date',
          type: 'month',
          valueFormat: 'yyyyMM'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.workefficiency'),
          apiUrl: '/protected/pc/report/sr/workingEfficiency/export'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        // srEmpNo: {
        //   label: this.$t("sfe.workEfficiency.srEmpNo")
        // },
        rsmName: {
          label: this.$t('sfe.workEfficiency.rsmName'),
          fixed: 'left'
        },
        asmName: {
          label: this.$t('sfe.workEfficiency.asmName'),
          fixed: 'left'
        },
        srEmpName: {
          label: this.$t('sfe.workEfficiency.srEmpName'),
          fixed: 'left'
        },
        visitQty: {
          label: this.$t('sfe.workEfficiency.visitQty')
        },
        visitDuration: {
          label: this.$t('sfe.workEfficiency.visitDuration')
        },
        visitStoreFrequency: {
          label: this.$t('sfe.workEfficiency.visitStoreFrequency')
        },
        visitStoreQty: {
          label: this.$t('sfe.workEfficiency.visitStoreQty')
        },
        recommendStoreFrequency: {
          label: this.$t('sfe.workEfficiency.recommendStoreFrequency')
        },
        recommendStoreQty: {
          label: this.$t('sfe.workEfficiency.recommendStoreQty')
        },
        purchaseStoreQty: {
          label: this.$t('sfe.workEfficiency.purchaseStoreQty')
        },
        unVisitDuration: {
          label: this.$t('sfe.workEfficiency.unVisitDuration')
        },
        totalWorkDuration: {
          label: this.$t('sfe.workEfficiency.totalWorkDuration')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/pc/report/sr/workingEfficiency/list'
      };
    }
  }
};